module.exports = __webpack_public_path__ + "media/src/images/styleguide/sample_modal_image-24605ea9055c77b38efaef342ba89041.png";